<account-back class="m-b-9 m-b-8-s m-b-8-m m-t--1 block p-l-2"
              [link]="backLink"
              [title]="(isNew ? 'Add new address' : 'Edit address')">
</account-back>

<account-form>
    <ng-form #form="ngForm">

        <input-wrap class="block p-l-1">
            <checkbox [(ngModel)]="data.is_shipping"
                      (ngModelChange)="detectChanges()"
                      name="is_shipping"
                      cy-primaryShippingAddressCheckbox>
                <span class="p1">
                    @if (data.is_shipping) {
                    {{'Primary delivery address'|translate}}
                    }
                    @if (!data.is_shipping) {
                    {{'Make this my primary delivery address'|translate}}
                    }
                </span>
            </checkbox>
        </input-wrap>

        <input-wrap class="block m-t-5 p-l-1">
            <checkbox [(ngModel)]="data.is_billing"
                      (ngModelChange)="detectChanges()"
                      name="is_billing"
                      cy-primaryBillingAddressCheckbox>
                <span class="p1">

                    @if (data.is_billing) {
                    {{'Primary billing address'|translate}}
                    }
                    @if (!data.is_billing) {
                    {{'Make this my primary billing address'|translate}}
                    }

                </span>
            </checkbox>
        </input-wrap>

        <account-address-fieldset [form]="form"
                                  class="block m-t-11 m-t-10-s"
                                  [isInEditor]="!isNew"
                                  [submitSubject]="submitSubject"
                                  [data]="data"></account-address-fieldset>

        <!-- submission -->
        <action class="button c-12 m-b-0 m-r-0 m-t-10"
                (click)="submit()"
                [status]="status">
            @if (!isNew) {
            <ng-container *ifSize="'!S'">
                {{ 'Save changes' | translate }}
            </ng-container>
            <ng-container *ifSize="'S'">
                {{ 'Save' | translate }}
            </ng-container>
            }
            @if (isNew) {
            {{ 'Add address' | translate }}
            }
        </action>
        <result [status]="status"></result>

        @if (!isNew) {
        <div class="center m-t-6 m-t-5-s">
            <action [status]="removeStatus"
                    *ifSize="'SM'"
                    class="button-inline s1"
                    (click)="delete()">
                <span class="col-2 fw-medium">
                    {{ 'Delete address' | translate }}
                </span>
            </action>
            <action-inline class="col-2 s2"
                           *ifSize="'XL'"
                           (click)="delete()"
                           [status]="removeStatus">
                {{ 'Delete address' | translate }}
            </action-inline>
        </div>
        }
    </ng-form>
</account-form>
